// Edit verdict (spec walkthrough 4, D6): the form's values, what's missing,
// and the body PATCH companies/{symbol}/verdict/ takes — the WHOLE verdict
// with a reason; what's left out is cleared.
import { withoutBidiControls } from "../../snippets/bidi";
import { verdictLabel } from "./format";

// What the form starts from is stored text, some of it written before the
// API refused bidi controls (D8): the form starts without them, or saving —
// which resends the whole verdict — would be refused every time.
const text = (value) => (value === null || value === undefined ? "" : withoutBidiControls(String(value)));

/** The form, starting from the company's verdict (unreviewed isn't a choice). */
export function formFromCompany(company) {
  const decided = company?.verdict && company.verdict !== "unreviewed";
  return {
    verdict: decided ? company.verdict : "",
    conviction: text(company?.conviction),
    exit_condition: text(company?.exit_condition),
    primary_thesis: text(company?.primary_thesis),
    reason: "",
  };
}

/** The form, starting from a proposal research made (the reason stays yours). */
export function formFromProposal(proposal) {
  return {
    verdict: text(proposal?.verdict),
    conviction: text(proposal?.conviction),
    exit_condition: text(proposal?.exit_condition),
    primary_thesis: text(proposal?.primary_thesis),
    reason: "",
  };
}

/** What stops the form being sent, by field: `{}` when nothing does. */
export function verdictProblems(form) {
  const problems = {};
  if (!form.verdict) problems.verdict = "Choose Watch, Own or Avoid.";
  if (form.verdict === "own" && !form.primary_thesis) {
    problems.primary_thesis = "An Own verdict names its primary thesis.";
  }
  if (!form.reason.trim()) problems.reason = "Say why — the history keeps it.";
  return problems;
}

/** The PATCH body: every field, null (or "") for what's left empty. */
export function verdictBody(form) {
  return {
    verdict: form.verdict,
    conviction: form.conviction ? Number(form.conviction) : null,
    exit_condition: form.exit_condition.trim(),
    primary_thesis: form.primary_thesis || null,
    reason: form.reason.trim(),
  };
}

/** "Proposed: Own (4)", or "Proposed: Watch" without a conviction. */
export function proposalLine(proposal) {
  const conviction = proposal?.conviction;
  const withConviction = conviction !== null && conviction !== undefined;
  return `Proposed: ${verdictLabel(proposal?.verdict)}${withConviction ? ` (${conviction})` : ""}`;
}
